import React, { useEffect, useRef } from 'react';
import { useDetailComponentData } from '@vendure/admin-ui/react';

/**
 * Custom detail component for the seller-detail page.
 * When creating a new seller (entity is null), pre-marks the `active` custom
 * field as `true` since Vendure's admin UI ignores the customField defaultValue.
 *
 * Renders nothing visible — pure side-effect component.
 */
const SellerCreateDefaults = () => {
  const { entity, detailForm } = useDetailComponentData();
  const appliedRef = useRef(false);

  useEffect(() => {
    if (appliedRef.current) return;
    // Only on create mode (no existing entity)
    if (entity != null) {
      appliedRef.current = true;
      return;
    }
    const activeControl = detailForm.get(['customFields', 'active']);
    if (activeControl && activeControl.value !== true) {
      activeControl.setValue(true);
      appliedRef.current = true;
    }
  }, [entity, detailForm]);

  return null;
};

export default SellerCreateDefaults;
